import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { MessageService } from 'primeng/api';

import { appRoutes } from './app-routing';
import { AppInterceptor } from './shared/interceptor';

import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BnNgIdleService } from 'bn-ng-idle';
import { AuthenticateGuard } from './authenticate/autheticate.guard';
import { AuthUtils } from './authenticate/autheticate.utils';
import { RoleGuardService } from './initial/initial-role-guard';
import { InitialAuthGuard } from './initial/initial.guard';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      IonicModule.forRoot(),

      // Keep only the ones used site-wide
      FormsModule,
      ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
      ModalModule.forRoot(),
      TabsModule.forRoot()
    ),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },

    // Global services
    MessageService,
    AuthUtils,
    InitialAuthGuard,
    RoleGuardService,
    AuthenticateGuard,
    BnNgIdleService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true,
    },
  ],
};
